// extracted by mini-css-extract-plugin
module.exports = {"stat-source-descr":"StatisticFromSource_stat-source-descr__d9qW8","stat-source-descr-logo":"StatisticFromSource_stat-source-descr-logo__mQwBD"};